import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import '../components/main.css'

const IndexPage = () => (
  <Layout lang="ru">
    <SEO title="Software Development Agency" />
    <div className="hero">Мы - компания по разработке программного обеспечения. Мы помогаем проектам на всех этапах цикла разработки программного продукта: от проверки гипотезы и создания MVP до масштабирования, аналитики и UX оптимизации.</div>
    <div className="animation"></div>
  </Layout>
)

export default IndexPage
